export default __webpack_public_path__ + "static/media/payment-processed.89fb9027.gif";